import React, { useEffect, useState } from "react";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Input, notification, Row } from "antd";
import { API } from "../../config/api";
import { GET, PUT } from "../../utils/apicalls";
import moment from "moment";
import PageHeader from "../../admin/pageHeader/pageheader";

function ProfileIndex() {
  const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const [UsersData, setUsersData] = useState<any>();

  const navigate = useNavigate();
  const [form] = Form.useForm();

  useEffect(() => {
    getUserData();
  }, []);

  const getUserData = async () => {
    try {
      let api = API.GET_ONE + user?.id;
      const Data: any = await GET(api, {});
      setUsersData(Data?.data);
      form.setFieldsValue(Data?.data);
    } catch (error) {
      console.log("Error fetching user data:", error);
    }
  };

  const onFinish = async (values: any) => {
    try {
      let obj = {
        type: UsersData.type,
        firstName: values.firstName,
        lastName: values.lastName,
        fullName: values.fullName,
        userName: values.userName,
        password: values.password,
        email: values.email,
        officeEmail: values.officeEmail,
        phone: values.phone,
        altPhone: values.altPhone,
        gender: values.gender,
        department: values.department,
        wrok_status: values.wrok_status,
        dob: values.dob,
        hireDate: values.hireDate,
        address: values.address,
        status: true,
        accountNo: values.accountNo,
        bankName: values.bankName,
        ifsc: values.ifsc,
        branch: values.branch,
        accountName: values.accountName,
        salary: Number(values.salary),
        id_Type: values.id_Type,
        id_Number: values.id_Number,
        id_Image1: values.id_Image1,
        bloodGroup: values.bloodGroup,
      };
      let api = API.EMPLOYEE_UPDATE + user.id;
      const postRequest: any = await PUT(api, obj);

      if (postRequest) {
        notification.success({
          message: "Employee details updated successfully",
        });
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    }
  };

  return (
    <div>
      <PageHeader>
        {" "}
        <Button onClick={() => navigate(`/Employee/viewSalaryDetails`)}>
          View Salary Details
        </Button>{" "}
      </PageHeader>
      <Card>
        <Form form={form} onFinish={onFinish} layout="vertical">
          {/* Personal Details Section */}
          <Row gutter={[16, 24]}>
            <Col span={24}>
              <h3>Personal Details</h3>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <h4>Date of Birth</h4>
              <p>
                {UsersData?.dob
                  ? moment(UsersData.dob).format("YYYY-MM-DD")
                  : "Not available."}
              </p>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <h4>hireDate</h4>
              <p>
                {UsersData?.hireDate
                  ? moment(UsersData.hireDate).format("YYYY-MM-DD")
                  : "Not available."}
              </p>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <h4>type</h4>
              <p>{UsersData?.type || "Not available."}</p>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <h4>salary</h4>
              <p>{UsersData?.salary || "Not available."}</p>
            </Col>
            {/* <Col sm={6}>
              <Form.Item name="type" label="type">
                <Input placeholder="Enter type" className="input-style" />
              </Form.Item>
            </Col> */}
            <Col sm={6}>
              <Form.Item
                name="fullName"
                label="Full Name"
                rules={[
                  { required: true, message: "Please enter your full name" },
                ]}
              >
                <Input placeholder="Enter full name" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="firstName"
                label="First Name"
                rules={[
                  { required: true, message: "Please enter your first name" },
                ]}
              >
                <Input placeholder="Enter first name" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="lastName"
                label="Last Name"
                rules={[
                  { required: true, message: "Please enter your last name" },
                ]}
              >
                <Input placeholder="Enter last name" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="userName"
                label="Username"
                rules={[
                  { required: true, message: "Please enter your username" },
                ]}
              >
                <Input placeholder="Enter username" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  { required: true, message: "Please enter your password" },
                ]}
              >
                <Input.Password
                  placeholder="Enter password"
                  className="input-style"
                />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    message: "Please enter your email",
                    type: "email",
                  },
                ]}
              >
                <Input placeholder="Enter email" className="input-style" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="officeEmail"
                label="Office Email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Enter a valid office email",
                  },
                ]}
              >
                <Input placeholder="Enter office email" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="phone"
                label="Phone"
                rules={[{ required: true, message: "Enter phone number" }]}
              >
                <Input placeholder="Enter phone number" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="altPhone" label="Alternate Phone">
                <Input placeholder="Enter alternate phone number" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="address"
                label="Address"
                rules={[{ required: true, message: "Enter address" }]}
              >
                <Input.TextArea placeholder="Enter address" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="department"
                label="Department"
                rules={[{ required: true, message: "Enter department" }]}
              >
                <Input placeholder="Enter department" />
              </Form.Item>
            </Col>
          </Row>

          {/* Bank Details Section */}
          <Row gutter={[16, 24]} className="mt-4">
            <Col span={24}>
              <h3>Bank Details</h3>
            </Col>
            <Col sm={6}>
              <Form.Item name="accountNo" label="Account Number">
                <Input placeholder="Enter account number" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="bankName" label="Bank Name">
                <Input placeholder="Enter bank name" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="ifsc" label="IFSC Code">
                <Input placeholder="Enter IFSC code" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="branch" label="Branch">
                <Input placeholder="Enter branch name" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="accountName" label="Account Name">
                <Input placeholder="Enter account holder name" />
              </Form.Item>
            </Col>
            {/* <Col sm={6}>
              <Form.Item
                name="salary"
                label="Salary"
                rules={[{ required: true, message: "Enter salary" }]}
              >
                <Input placeholder="Enter salary" />
              </Form.Item>
            </Col> */}
          </Row>

          {/* ID Details Section */}
          <Row gutter={[16, 24]} className="mt-4">
            <Col span={24}>
              <h3>ID Details</h3>
            </Col>
            <Col sm={6}>
              <Form.Item name="id_Type" label="ID Type">
                <Input placeholder="Enter ID type" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="id_Number" label="ID Number">
                <Input placeholder="Enter ID number" />
              </Form.Item>
            </Col>
            {/* <Col sm={6}>
              <Form.Item name="id_Image1" label="ID Image">
                <Input type="file" />
              </Form.Item>
            </Col> */}
            <Col sm={6}>
              <Form.Item name="bloodGroup" label="Blood Group">
                <Input placeholder="Enter blood group" />
              </Form.Item>
            </Col>
          </Row>

          {/* Buttons */}
          <Row className="mt-4" gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Button
                onClick={() => navigate("/Admin/Dashboard")}
                size="large"
                block
                className="cancel-button"
              >
                Cancel
              </Button>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                block
                className="update-button"
              >
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default ProfileIndex;
